//
// Filter is a generic filter header with all optional filters:
// 1. Four Search Input Filter.
// 2. One Search Dropdown Input Filter.
// 3. Two Date Input Filter.
// 4. Three Dropdown Input Filter.
//

import React from "react";
import AsyncSelect from "react-select/async";

export const SearchFilter = ({ searchLabel, searchPlaceholder, searchVal, onSearchChange, specialColClass, colClass }) => {
  const columnClass = colClass ? colClass : "col-12 col-sm-4";
  return (
    <div className={specialColClass ? specialColClass : columnClass}>
      <label className="col-form-label filter-label" htmlFor="select">
        <i className="fa fa-search mr-05 ml-05"></i>
        {searchLabel}
      </label>
      <input type="text" id="search" className="form-control" placeholder={searchPlaceholder} value={searchVal} onChange={onSearchChange} />
    </div>
  );
};

export const SearchDropdownFilter = ({
  searchDropdownLabel,
  searchDropdownPlaceholder,
  searchDropdownVal,
  onSearchDropdownChange,
  loadSearchDropdownOptions,
  isLoadingSearchDropdown,
  specialColClass,
  colClass,
}) => {
  const columnClass = colClass ? colClass : "col-12 col-sm-4";
  return (
    <div className={specialColClass ? specialColClass : columnClass}>
      <label className="col-form-label filter-label" htmlFor="select">
        <i className="fa fa-search mr-05 ml-05"></i>
        {searchDropdownLabel}
      </label>
      <AsyncSelect
        name="form-field-name"
        matchProp="label"
        loadOptions={loadSearchDropdownOptions}
        isLoading={isLoadingSearchDropdown}
        onChange={onSearchDropdownChange}
        value={searchDropdownVal}
        placeholder={searchDropdownPlaceholder}
        defaultOptions
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            neutral20: "#e9ebec",
          },
        })}
      />
    </div>
  );
};

export const DateFilter = ({ dateLabel, dateVal, onDateChange, colClass }) => {
  const columnClass = colClass ? colClass : "col-12 col-sm-4";
  return (
    <div className={columnClass}>
      <label className="col-form-label filter-label" htmlFor="select">
        <i className="fa fa-calendar-o mr-05 ml-05"></i>
        {dateLabel ? dateLabel : "Date"}
      </label>
      <input type="date" id="date" className="form-control" value={dateVal} onChange={(date) => onDateChange(date)} />
    </div>
  );
};

export const InlineDateFilter = ({ dateLabel, dateToVal, dateFromVal, onDateToChange, onDateFromChange }) => {
  return (
    <div className="col-sm-12 col-md-6">
      <label className="col-form-label filter-label" htmlFor="select">
        <i className="fa fa-calendar-o mr-05 ml-05"></i>
        {dateLabel ? dateLabel : "Date"}
      </label>
      <div className="d-flex flex-row">
        <input
          type="date"
          id="dateFrom"
          className="form-control"
          style={{ marginRight: "30px" }}
          value={dateFromVal}
          onChange={(date) => onDateFromChange(date)}
        />
        <input type="date" id="dateTo" className="form-control" value={dateToVal} onChange={(date) => onDateToChange(date)} />
      </div>
    </div>
  );
};

export const InlinePriceFilter = ({ priceLabel, priceMaxVal, priceMinVal, onPriceMaxChange, onPriceMinChange }) => {
  return (
    <div className="col-sm-12 col-md-6">
      <label className="col-form-label filter-label" htmlFor="select">
        <i className="fa fa-search mr-05 ml-05"></i>
        {priceLabel}
      </label>
      <div className="d-flex flex-row">
        <input
          type="number"
          id="priceMin"
          className="form-control"
          style={{ marginRight: "30px" }}
          placeholder="Min"
          value={priceMinVal}
          onChange={onPriceMinChange}
        />
        <input type="number" id="priceMax" className="form-control" placeholder="Max" value={priceMaxVal} onChange={onPriceMaxChange} />
      </div>
    </div>
  );
};

export const DropdownFilter = ({
  dropdownLabel,
  dropdownPlaceholder,
  dropdownVal,
  onDropdownChange,
  dropdownByElement,
  dropdownByElementId,
  dropdownOptions,
  colClass,
}) => {
  const columnClass = colClass ? colClass : "col-12 col-sm-4";
  return (
    <div className={columnClass}>
      {dropdownLabel && (
        <label className="col-form-label filter-label ml-05" htmlFor="select">
          {dropdownLabel}
        </label>
      )}
      <select className="form-control" id="select" name="select" value={dropdownVal} onChange={onDropdownChange}>
        <option value={-1}>{dropdownPlaceholder}</option>
        {dropdownOptions ? (
          dropdownOptions.map((elem, index) => {
            return (
              <option value={dropdownByElement ? elem : dropdownByElementId ? elem.id : index} key={dropdownByElement ? elem : elem.id}>
                {dropdownByElement
                  ? elem
                  : dropdownLabel && dropdownLabel.toLowerCase().includes("brand")
                  ? elem.brand_name
                  : dropdownLabel && dropdownLabel.toLowerCase().includes("grade")
                  ? elem.grade
                  : elem.name}
              </option>
            );
          })
        ) : (
          <option value=" ">Loading...</option>
        )}
      </select>
    </div>
  );
};

const Filter = (props) => {
  const colClass = props.colClass ? props.colClass : "col-12 col-sm-4";
  return (
    <div className="card-header reports-filter">
      <form className="row mb-1">
        {/* Search Filter */}
        {props.searchLabel && (
          <SearchFilter
            searchLabel={props.searchLabel}
            searchPlaceholder={props.searchPlaceholder}
            searchVal={props.searchVal}
            onSearchChange={props.onSearchChange}
            specialColClass={props.specialColClass}
            colClass={colClass}
          />
        )}

        {/* Second Search Filter */}
        {props.searchLabel2 && (
          <SearchFilter
            searchLabel={props.searchLabel2}
            searchPlaceholder={props.searchPlaceholder2}
            searchVal={props.searchVal2}
            onSearchChange={props.onSearchChange2}
            specialColClass={props.specialColClass}
            colClass={colClass}
          />
        )}

        {/* Search With Dropdown Filter */}
        {props.searchDropdownLabel && (
          <SearchDropdownFilter
            searchDropdownLabel={props.searchDropdownLabel}
            searchDropdownPlaceholder={props.searchDropdownPlaceholder}
            searchDropdownVal={props.searchDropdownVal}
            onSearchDropdownChange={props.onSearchDropdownChange}
            loadSearchDropdownOptions={props.loadSearchDropdownOptions}
            isLoadingSearchDropdown={props.isLoadingSearchDropdown}
            specialColClass={props.specialColClass}
            colClass={colClass}
          />
        )}

        {/* Date Filter */}
        {props.dateLabel && (
          <DateFilter dateLabel={props.dateLabel} dateVal={props.dateVal} onDateChange={props.onDateChange} colClass={colClass} />
        )}

        {/* Second Date Filter */}
        {props.dateLabel2 && (
          <DateFilter dateLabel={props.dateLabel2} dateVal={props.dateVal2} onDateChange={props.onDateChange2} colClass={colClass} />
        )}

        {/* Dropdown Filter */}
        {props.dropdownLabel && (
          <DropdownFilter
            dropdownLabel={props.dropdownLabel}
            dropdownPlaceholder={props.dropdownPlaceholder}
            dropdownVal={props.dropdownVal}
            onDropdownChange={props.onDropdownChange}
            dropdownByElement={props.dropdownByElement}
            dropdownByElementId={props.dropdownByElementId}
            dropdownOptions={props.dropdownOptions}
            colClass={colClass}
          />
        )}

        {/* Second Dropdown Filter */}
        {props.dropdownLabel2 && (
          <DropdownFilter
            dropdownLabel={props.dropdownLabel2}
            dropdownPlaceholder={props.dropdownPlaceholder2}
            dropdownVal={props.dropdownVal2}
            onDropdownChange={props.onDropdownChange2}
            dropdownByElement={props.dropdownByElement2}
            dropdownByElementId={props.dropdownByElementId2}
            dropdownOptions={props.dropdownOptions2}
            colClass={colClass}
          />
        )}

        {/* Third Search Filter */}
        {props.searchLabel3 && (
          <SearchFilter
            searchLabel={props.searchLabel3}
            searchPlaceholder={props.searchPlaceholder3}
            searchVal={props.searchVal3}
            onSearchChange={props.onSearchChange3}
            specialColClass={props.specialColClass}
            colClass={colClass}
          />
        )}

        {/* Fourth Search Filter */}
        {props.searchLabel4 && (
          <SearchFilter
            searchLabel={props.searchLabel4}
            searchPlaceholder={props.searchPlaceholder4}
            searchVal={props.searchVal4}
            onSearchChange={props.onSearchChange4}
            specialColClass={props.specialColClass}
            colClass={colClass}
          />
        )}

        {/* Third Dropdown Filter */}
        {props.dropdownLabel3 && (
          <DropdownFilter
            dropdownLabel={props.dropdownLabel3}
            dropdownPlaceholder={props.dropdownPlaceholder3}
            dropdownVal={props.dropdownVal3}
            onDropdownChange={props.onDropdownChange3}
            dropdownByElement={props.dropdownByElement3}
            dropdownByElementId={props.dropdownByElementId3}
            dropdownOptions={props.dropdownOptions3}
            colClass={colClass}
          />
        )}

        {/* Fourth Dropdown Filter */}
        {props.dropdownLabel4 && (
          <DropdownFilter
            dropdownLabel={props.dropdownLabel4}
            dropdownPlaceholder={props.dropdownPlaceholder4}
            dropdownVal={props.dropdownVal4}
            onDropdownChange={props.onDropdownChange4}
            dropdownByElement={props.dropdownByElement4}
            dropdownByElementId={props.dropdownByElementId4}
            dropdownOptions={props.dropdownOptions4}
            colClass={colClass}
          />
        )}

        {/* Inline Date Filter */}
        {props.inlineDateLabel && (
          <InlineDateFilter
            dateLabel={props.inlineDateLabel}
            dateToVal={props.dateToVal}
            dateFromVal={props.dateFromVal}
            onDateToChange={props.onDateToChange}
            onDateFromChange={props.onDateFromChange}
            colClass={colClass}
          />
        )}

        {/* Inline price Filter */}
        {props.inlinePriceLabel && (
          <InlinePriceFilter
            priceLabel={props.inlinePriceLabel}
            priceMaxVal={props.priceMaxVal}
            priceMinVal={props.priceMinVal}
            onPriceMaxChange={props.onPriceMaxChange}
            onPriceMinChange={props.onPriceMinChange}
            colClass={colClass}
          />
        )}
      </form>
    </div>
  );
};

export default Filter;
